//
// ReportAssetURLType.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ReportAssetURLType = {
    REPORT:0,
    DATA:1,
    IMAGE:2,
    XML:3,
    CSS:4,
    STP:5,
    PACKAGE:6,
    REQUERY:7,
    REPORTSTATE:8,
    RESOURCE:9
};
export default ReportAssetURLType;
